<template>
  <el-dialog
    :title="$t('resend_confirmation.title')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape=true
    custom-class="elsa-modal"
    :center=false
    width="255"
    top="100px"
    v-on:closed="closed"
  >
    <slot >
      <api-errors :errors="errors" />
      <h2>{{ $t('resend_confirmation.send_confirmation') }}</h2>
      <el-form class="auth-form" :model="form" :rules="rules" ref="form" @change.native="onFormChange">
        <elsa-input
          name="email"
          :label="$t('resend_confirmation.email_field.label')"
          :placeholder="$t('resend_confirmation.email_field.placeholder')"
          v-model.trim.lazy="form.email"
        >
          {{ $t('resend_confirmation.email_field.label') }}
        </elsa-input>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <primary-button @click.native="handleSubmit" ref="submit" disabled>{{ $t('resend_confirmation.resend_email') }}</primary-button>
      </span>
    </slot>
  </el-dialog>
</template>

<script>
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import ElsaInput from '@/components/common/Input'
import ApiErrors from '@/components/common/ApiErrors'
import { handleFormValidation, handleSubmitButtonState, isPropEmpty } from '@/helpers/formValidationHelper'
import axios from 'axios'
import { compose, isEmpty, either, isNil, not } from 'ramda'

export default {
  props: ["dialogVisible"],
  components: {
    PrimaryButton,
    ElsaInput,
    ApiErrors
  },
  methods: {
    showModal() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    onFormChange() {
      handleSubmitButtonState(this.$refs.submit.$el, !isPropEmpty("email")(this.form))
    },
    handleSubmit() {
      handleFormValidation(this.$refs.form, this.sendConfirmationEmail, () => { this.dialogVisible = true })
    },
    sendConfirmationEmail() {
      axios.post('send-confirmation', { ...this.form })
        .then(() => {
          this.resetForm()
          this.closed()
        }
      ).catch((error) => {
        this.errors = error.response.data || [{ message: this.$t('common.generic_error_message') }]
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.errors = []
    },
    closed () {
      this.$emit("closed")
    },
  },
  data() {
    return {
      form: {},
      errors: [],
      rules: {
        email: [
          { type: 'email', message: this.$t('resend_confirmation.email_field.format_validation_msg'), trigger: ['change'] },
          {
              message: this.$t('resend_confirmation.email_field.validation_msg'),
              trigger: ['change'],
              validator: (rule, value, callback) => {
                const isValid = compose(not, either(isNil, isEmpty))
                if(!isValid(value)) { return callback(new Error(this.$t('resend_confirmation.email_field.validation_msg'))) }
                return callback();
              }
            },
        ]
      }
    }
  },

}
</script>

<style lang="scss" scoped>
  .el-dialog.elsa-modal .el-dialog__body {
    h2 {
      opacity: 1;
      padding-bottom: 16px;
      line-height: 28px;
    }

    p {
      font-weight: 300;
      font-size: 13px;
      padding-bottom: 32px;
      align-self: flex-start;
    }

    a {
      cursor: pointer;
    }
    form {
      width: 100%;
      margin-top: 20px;
    }
  }

  .elsa-button {
    width: 202px;
  }
</style>
